module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/call-1-5a293e34ba8d21b05cf38baa2621182d.svg";